import { Box } from "@/components/layout/flexbox";
import { TimelineItem } from "@/components/pieces/Timeline";
import { SUBTEXT_COLOR } from "@/css/constants";

interface ReviewTimelineItemProps {
  intent?: string;
  label: string;
  message?: string;
}

export function ReviewTimelineItem({
  intent,
  label,
  message,
}: ReviewTimelineItemProps) {
  return (
    <TimelineItem intent={intent}>
      <Box>{label}</Box>
      {message ? (
        <Box color={SUBTEXT_COLOR} fontSize={14} mt={2}>
          {message}
        </Box>
      ) : null}
    </TimelineItem>
  );
}
